import { AdIconList, AdPriceList, IconLinkList, InfoList, TitleTextItem } from "../types/CommonComponents";
import { FilterDataType } from "../types/Product";

export const JobAllCategoriesData: FilterDataType[] = [
  { id: "Categories-1", label: "Education", type: "education" , count: 107},
  { id: "Categories-2", label: "Law & government", type: "law_&_government" , count: 51},
  { id: "Categories-3", label: "Arts", type: "arts" , count: 61},
  { id: "Categories-4", label: "Construction", type: "construction" , count: 51},
  { id: "Categories-5", label: "Finance", type: "finance" , count: 17},
  { id: "Categories-6", label: "Technology", type: "technology" , count: 15},
  { id: "Categories-7", label: "Communications", type: "communications" , count: 19},
  { id: "Categories-8", label: "Health care", type: "health_care" , count: 81},
];

export const JobWorkModeData: FilterDataType[] = [
  { id: "Work-1", label: "Work From Office", type: "work_from_office" , count: 99},
  { id: "Work-2", label: "Hybrid", type: "hybrid" , count: 5},
  { id: "Work-3", label: "Remote", type: "remote" , count: 10},
  { id: "Work-4", label: "Freelancing", type: "freelancing" , count: 51},
];

export const JobCompanyTypeData: FilterDataType[] = [
  { id: "Company-1", label: "Foreign MNC", type: "foreign_mnc" , count: 10},
  { id: "Company-2", label: "Indian MNC", type: "indian_mnc" , count: 50},
  { id: "Company-3", label: "Startup", type: "startup" , count: 80},
  { id: "Company-4", label: "Corporate", type: "corporate" , count: 16},
  { id: "Company-5", label: "Government", type: "government" , count: 71},
  { id: "Company-6", label: "Others", type: "others" , count: 61},
];

export const JobEducationData: FilterDataType[] = [
  { id: "Education-1", label: "Any Postgraduate", type: "any_postgraduate" , count: 88},
  { id: "Education-2", label: "M.Tech", type: "m_tech" , count: 66},
  { id: "Education-3", label: "MCA", type: "mca" , count: 55},
  { id: "Education-4", label: "B.SC", type: "b_sc" , count: 44},
  { id: "Education-5", label: "Graduation Not Required", type: "graduation_not_required" , count: 33},
  { id: "Education-6", label: "Medical - Ms / md", type: "medical_ms_md" , count: 22},
  { id: "Education-7", label: "Any Graduate", type: "any_graduate" , count: 11},
  { id: "Education-8", label: "Other Graduate", type: "other_graduate" , count: 99},
];

export const JobByData: FilterDataType[] = [
  { id: "By-1", label: "Company Jobs", type: "company_jobs" , count: 51},
  { id: "By-2", label: "Consultant Jobs", type: "consultant_jobs" , count: 1},
];

export const JobLocationData: FilterDataType[] = [
  { id: "Location-1", label: "Honolulu", type: "honolulu" , count: 17},
  { id: "Location-2", label: "Kansas City", type: "kansas_city" , count: 61},
  { id: "Location-3", label: "London", type: "london" , count: 81},
  { id: "Location-4", label: "Munich", type: "munich" , count: 91},
  { id: "Location-5", label: "Ottawa", type: "ottawa" , count: 61},
  { id: "Location-6", label: "Prague", type: "prague" , count: 4},
];

export const JobTopCompaniesData: FilterDataType[] = [
  { id: "TopCompanies-1", label: "Future Infotech", type: "future_infotech" , count: 17},
  { id: "TopCompanies-2", label: "Soylent", type: "soylent" , count: 61},
  { id: "TopCompanies-3", label: "Deal Design", type: "deal_design" , count: 17},
  { id: "TopCompanies-4", label: "Flashed Craft", type: "flashed_craft" , count: 98},
  { id: "TopCompanies-5", label: "Tech Rayan", type: "tech_rayan" , count: 59},
];

export const JobTypeData: FilterDataType[] = [
  { id: "JobType-1", label: "Freelancing", type: "freelancing" , count: 87},
  { id: "JobType-2", label: "Full Time", type: "full_time" , count: 45},
  { id: "JobType-3", label: "Interneship", type: "internship" , count: 76},
  { id: "JobType-4", label: "Part Time", type: "part_time" , count: 45},
  { id: "JobType-5", label: "Temporary", type: "temporary" , count: 18},
];

export const AdListData: string[] = ["Fresher", "Less than 1 Month", "Less than 2 Month", "Less than 3 Month", "Less than 4 Month"];

export const AdPriceListData: AdPriceList[] = [
  { price: "$1800", value: "35865" },
  { price: "$2400", value: "21604" },
  { price: "$3000", value: "58147" },
  { price: "$3500", value: "65015" },
  { price: "$3800", value: "51416" },
  { price: "$4500", value: "78627" },
];

export const AdIconListData: AdIconList[] = [
  { icon: "😔", text: "Not Useful" },
  { icon: "😌", text: "Neutral" },
  { icon: "🙂", text: "Very Useful" },
];

export const InfoListData: InfoList[] = [
  { image: "develop", title: "Department", text: "Development" },
  { image: "location", title: "Location", text: "Puerta 830 Grupo" },
  { image: "dollar", title: "Salary", text: "$18-20K USD" },
];

export const AboutTheRoleData: string[] = ["Allies Infotech is seeking a highly motivated and results-driven Business Development Executive to join our growing team. The successful candidate will play a crucial role in identifying new business opportunities, building relationships, and driving revenue growth. The Business Development Executive will be responsible for creating and implementing effective strategies to expand our customer base and achieve sales targets."];

export const JobLikeData: string[] = ["Gain knowledge about all the services and products that our business has to offer.", "Acquiring new customers through direct contact, by word-of-mouth, or by implementing new marketing strategies", "Exceptional networking and public relations abilities to attract potential clients", "Negotiate terms and close deals to achieve revenue targets while ensuring customer satisfaction.", "Preserving close connections with current clients to make sure their expectations are fulfilled in a timely and efficient manner"];

export const CanApplyData: string[] = ["Diploma/Bachelors’/Masters’ in Software Development, Computer Science, Information Technology or a related field.", "Fundamental knowledge in IT sales and marketing", "Knowledge of bidding on freelancing portals such as Freelancer, Upwork, Guru, Fiverr, etc.", "Outstanding networking abilities", "Strong verbal and written communication", "Resourceful and possesses remarkable research abilities", "Capability to communicate ideas and explain concepts to a range of audiences", "Impressive client service abilities", "Talent to sell value and maintain a good reputation"];

export const SkillListData: string[] = ["Figma", "UX Research Skills", "Sketch", "Adobe XD"];

export const BenefitsListData: string[] = ["Positive Work Environment", "5-Days Working", "Paid Leaves", "Complimentary Health Insurance", "Fun Activities", "Overtime Pay", "Personal Loan", "Employee Training", "Professional Developments", "Annual Picnic"];

export const ApplyForJobListData: TitleTextItem[] = [
  { title: "Position:", text: "3" },
  { title: "Experience:", text: "0 to 1.5 years of experience" },
  { title: "Location:", text: "Amsterdam - Hollowland" },
  { title: "Work Mode:", text: "Full Time" },
];

export const SocialListData: IconLinkList[] = [
  { icon: "ri-linkedin-line", url: "https://in.linkedin.com/" },
  { icon: "ri-mail-line", url: "https://mail.google.com/" },
  { icon: "ri-twitter-line", url: "https://x.com/" },
  { icon: "ri-whatsapp-line", url: "https://web.whatsapp.com/" },
];

export const IntroductionData: string[] = ["Game designers create the concepts and worlds of Mobile games. They are involved with the use to design of the 3DS Max, Maya, Zbrush, Software and create the user experience of Mobile games. Game designers create the concepts and worlds of Mobile games."];

export const KeyJobDetailsData: InfoList[] = [
  { image: "17", title: "Vacancy", text: "3" },
  { image: "15", title: "Employment Type", text: "Full Time" },
  { image: "12", title: "Role", text: "Bussiness Development" },
  { image: "14", title: "Experience", text: "0-1.5 Years" },
  { image: "13", title: "Contract Type", text: "Regular" },
  { image: "16", title: "Location", text: "Hollowland" },
];

export const SimilarJobsData: string[] = ["Similar Jobs", "Other Jobs Form Allies Infotech"];
